import each from 'lodash/each';
import debounce from 'lodash/debounce';
import cloneDeep from 'lodash/cloneDeep';
import isElement from 'lodash/isElement';
import isEmpty from 'lodash/isEmpty';
import throttle from 'lodash/throttle';
import assign from 'lodash/assign';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import once from 'lodash/once';
import isObject from 'lodash/isObject';
import flattenDeep from 'lodash/flattenDeep';
import get from 'lodash/get';
import size from 'lodash/size';
import trimEnd from 'lodash/trimEnd';
import trim from 'lodash/trim';
import isEqual from 'lodash/isEqual';
import forEach from 'lodash/forEach';
import flatten from 'lodash/flatten';
import setWith from 'lodash/setWith';
import sample from 'lodash/sample';
import includes from 'lodash/includes';
import values from 'lodash/values';
import keys from 'lodash/keys';

global._ = {
	assign,
	cloneDeep,
	debounce,
	flattenDeep,
	get,
	isObject,
	isEqual,
	each,
	flatten,
	forEach,
	isElement,
	isEmpty,
	isNumber,
	includes,
	isString,
	once,
	throttle,
	trim,
	setWith,
	sample,
	size,
	trimEnd,
	values,
	keys,
};